



































































import { Component } from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import api, { SecuritylApi } from '@/views/settings/security/api';
import ApiServices from '@/services';
 import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'

  @Component({
    components: {
      FormOverlay,
      DialogForm,
      HeaderButtons
    }
  })
  export default class DisableDialog extends Form {
    edit: boolean = true;
    loading: boolean = false;
    saved: boolean = false;
    show_password: boolean = false;
    password: string = '';
    api: SecuritylApi = api;
    form: any = {};

    close() {
      this.$emit('close');
    }

    @Send()
    submit() {
      return this.api.postTwoFactorDisable({
        password: this.password
      })
      .then((payload: any) => {
        ApiServices.getUserProfile().then(() => {
          this.close()
          return payload;
        });
      })
    }
  }
